/** @enum {string} */
export const Properties = Object.freeze({
  ABBREVIATION: 'abbreviation',
  ACRONYM: 'acronym',
  ACT_TYPE: 'actType',
  ACTS_MANDATORY: 'actsMandatory',
  ADDRESS: 'address',
  BIRTHDAY: 'birthday',
  CITY: 'city',
  COMMENT: 'comment',
  COUNTRY: 'country',
  CREATED_AT: 'createdAt',
  DESCRIPTION: 'description',
  EMAIL: 'email',
  END_DATE: 'endDate',
  ID: 'id',
  FILES: 'files',
  FIRST_NAME: 'firstName',
  GENDER: 'gender',
  GLOBAL_MESSAGE: 'gloablMessage',
  HOSPITAL_DEPARTMENTS: 'hospitalDepartments',
  INSTITUTION: 'institution',
  INSTITUTIONS: 'institutions',
  INSTITUTION_ACRONYM: 'institutionAcronym',
  INSTITUTION_ADDRESS: 'institutionAddress',
  INSTITUTION_CITY: 'institutionCity',
  INSTITUTION_COUNTRY: 'institutionCountry',
  INSTITUTION_EMAIL: 'institutionEmail',
  INSTITUTION_GROUP: 'institutionGroup',
  INSTITUTION_NAME: 'institutionName',
  INSTITUTION_ZIPCODE: 'institutionZipcode',
  INTERNSHIP: 'internship',
  DURATION: 'duration',
  DURATION_TYPE: 'durationType',
  LANGUAGE_LOCALE: 'languageLocale',
  LAST_NAME: 'lastName',
  MANAGED: 'managed',
  NAME: 'name',
  NISS: 'niss',
  PHONE: 'phone',
  PHONE_NUMBER: 'phoneNumber',
  PREMIUM: 'premium',
  REQUEST_ORIGIN: 'requestOrigin',
  REQUEST_PERIODS: 'requestPeriods',
  SCHOOL: 'school',
  SECTION: 'section',
  SECTIONS: 'sections',
  SECTION_GROUP: 'sectionGroup',
  SECTION_TO_YEAR: 'sectionToYear',
  SECTOR: 'sector',
  SECTOR_NAME: 'sectorName',
  START_DATE: 'startDate',
  STUDENT: 'student',
  TOTAL: 'total',
  VERIFIED: 'verified',
  ZIPCODE: 'zipcode'
})
